<h2 mat-dialog-title>Digite a senha para liberar o acesso</h2>

<mat-dialog-content>
  <mat-form-field class="full-width">
    <mat-label>Senha</mat-label>
    <input
      matInput
      [(ngModel)]="password"
      type="password"
      placeholder="Digite a senha"
      autocomplete="new-password"
    />
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    (click)="confirm()"
    [disabled]="!password"
  >
    Confirmar
  </button>
</mat-dialog-actions>
